import React from "react";
import { Row, Col } from "react-flexbox-grid";
import "./contactSocial.scss";
import { SocialIcon } from 'react-social-icons';

const contactSocial = () => (
  <Row center="lg">
    <Col xs={3} lg={1}></Col>
    <Col xs={3} lg={1} className="contact__social">
      <SocialIcon bgColor="#ea4335" url="mailto:t.anis60.ta@gmail.com" target="_blank" rel="noopener noreferrer" />
    </Col>
    <Col xs={3} lg={1} className="contact__social">
      <SocialIcon url="https://www.linkedin.com/in/talha-anis/" target="_blank" rel="noopener noreferrer" />
    </Col>
    {/* WhatsApp button that opens in new tab and shows correct icon */}
    <Col xs={3} lg={1} className="contact__social">
      <SocialIcon network="whatsapp" url="https://wa.me/923355703007" target="_blank" rel="noopener noreferrer" />
    </Col>
  </Row>
);

export default contactSocial;
